
export const TOUR_KEY = "payment-settlement-tour-seen";

export const markPaymentSettlementTourSeen = () => {
  localStorage.setItem(TOUR_KEY, "true");
};

export const markPaymentSettlementTourCompleted = () => {
  localStorage.setItem(TOUR_KEY, "true");
};

export const hasSeenPaymentSettlementTour = () => {
  return localStorage.getItem(TOUR_KEY) === "true";
};

